module.exports = "<div class=\"bar progress-total\">\n    <div class=\"progress-current\" style=\"width:{{ $ctrl.progress * 100 }}%\"></div>\n</div>\n<div class=\"text\">{{ $ctrl.text }}</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/progressbar/progressbar.html
// module id = 670
// module chunks = 3